// src/slices/categoriesSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchCategories as fetchCategoriesApi,
  fetchCategoriesByAffiliate as fetchCategoriesByAffiliateApi,
  fetchCategoryById as fetchCategoryByIdApi,
} from "../../api/api_categories";

// Async thunk for fetching all categories
export const fetchCategoriesThunk = createAsyncThunk(
  "categories/fetchCategories",
  async () => {
    const response = await fetchCategoriesApi();
    return response; // Return only serializable `data`
  }
);

// Async thunk for fetching categories by affiliate
export const fetchCategoriesByAffiliateThunk = createAsyncThunk(
  "categories/fetchCategoriesByAffiliate",
  async () => {
    const response = await fetchCategoriesByAffiliateApi();
    return response; // Return only serializable `data`
  }
);

// Async thunk for fetching a category by id
export const fetchCategoryByIdThunk = createAsyncThunk(
  "categories/fetchCategoryById",
  async (categoryId) => {
    const response = await fetchCategoryByIdApi(categoryId);
    return response.data; // Return only serializable `data`
  }
)

const categoriesSlice = createSlice({
  name: "categories",
  initialState: {
    items: [],
    affiliateCategories: [],
    category: null,
    status: "idle",
    affiliateStatus: "idle",
    error: null,
    affiliateError: null,
    categoryAverages: null,
  },
  reducers: {
    updateCategoryList: (state, action) => {
      state.affiliateCategories.push(action.payload);
    },
    updateCategoryInStore: (state, action) => {
      const { id, name, image } = action.payload;
      const category = state.affiliateCategories.find((cat) => cat.id === id);
      if (category) {
        category.name = name;
        category.image = image;
      }
    },
    deleteCategoryInStore: (state, action) => {
      const categoryId = action.payload;
      state.affiliateCategories = state.affiliateCategories.filter(
        (cat) => cat.id !== categoryId
      );
    },
    addDishToCategory: (state, action) => {
      const dish = action.payload;
      state.category.dishes.push(dish);
    },

   deleteDish: (state, action) => {
      const dishId = action.payload;
      state.category.dishes = state.category.dishes.filter(
        (dish) => dish.id !== dishId
      );
    },
    setCategoryAverages: (state, action) => {
      state.categoryAverages = action.payload.data;
    },
  },

  extraReducers: (builder) => {
    builder
      // Handle fetchCategoriesThunk
      .addCase(fetchCategoriesThunk.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCategoriesThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload;
      })
      .addCase(fetchCategoriesThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // Handle fetchCategoriesByAffiliateThunk
      .addCase(fetchCategoriesByAffiliateThunk.pending, (state) => {
        state.affiliateStatus = "loading";
      })
      .addCase(fetchCategoriesByAffiliateThunk.fulfilled, (state, action) => {
        state.affiliateStatus = "succeeded";
        state.affiliateCategories = action.payload;
      })
      .addCase(fetchCategoriesByAffiliateThunk.rejected, (state, action) => {
        state.affiliateStatus = "failed";
        state.affiliateError = action.error.message;
      })

      // Handle fetchCategoryByIdThunk
      .addCase(fetchCategoryByIdThunk.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCategoryByIdThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.category = action.payload;
      })
      .addCase(fetchCategoryByIdThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { updateCategoryInStore, deleteCategoryInStore,addDishToCategory,updateCategoryList,deleteDish,setCategoryAverages } =
  categoriesSlice.actions;

export default categoriesSlice.reducer;
